/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_Sort_TitleInputs */

const en_drawer_sort_title = /** @type {(inputs: Drawer_Sort_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title A–Z`)
};

const id_drawer_sort_title = /** @type {(inputs: Drawer_Sort_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul A–Z`)
};

/**
* | output |
* | --- |
* | "Title A–Z" |
*
* @param {Drawer_Sort_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_sort_title = /** @type {((inputs?: Drawer_Sort_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_Sort_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_sort_title(inputs)
	return en_drawer_sort_title(inputs)
});